<template>
  <div class="wrapper">
    <admin-title :title="$route.params.id ? '编辑' : '新增'"></admin-title>
    <a-divider />
      <el-form ref="form" :model="formData" label-width="130px" :rules="rules">
        <el-form-item label="字典名称" prop="dictName">
          <el-input v-model="formData.dictName" placeholder="请输入字典名称"></el-input>
        </el-form-item>
        <el-form-item label="字典标识" prop="dictCode">
          <el-input v-model="formData.dictCode" placeholder="请输入字典标识" :disabled="$route.params.id ? true : false"></el-input>
        </el-form-item>
        <el-form-item label="权重" prop="weight">
          <el-input v-model="formData.weight" placeholder="请输入权重" :disabled="$route.params.id ? true : false"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="formData.remark"></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="info" @click="cancel">取消</el-button>
          <el-button type="primary" @click="save">保存</el-button>
        </el-form-item>
      </el-form>

  </div>
</template>

<script>
import { getDictDetail, addDict, editDict} from './api';

export default {
  name: 'DictAddOrEdit',
  data() {
    return {
      formData: {
        dictCode: '',
        dictName: '',
        weight: '',
        remark: '',
      },
      rules: {
        dictCode: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
        dictName: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
        weight: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
      },
    }
  },

  mounted() {
    if (this.$route.params.id) {
      this.apiQueryDict(this.$route.params.id);
    }
  },

  methods: {
    save() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (this.$route.params.id) {
            this.formData.id = this.$route.params.id
            await editDict(this.formData).then(() => {
              this.$message.success('编辑成功');
              this.$router.back();
            });
          } else {
            await addDict(this.formData).then(() => {
              this.$message.success('新增成功');
              this.$router.back();
            });
          }
        } else {
          return false;
        }
      })
    },
    cancel() {
      this.$router.back(-1);
    },
    async apiQueryDict(id) {
      this.formData = await getDictDetail(id);
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;

  .el-form /deep/ {
    .el-form-item {
      .el-form-item__content {
        width: 50%;
      }
      .el-cascader {
        width: 100%;
      }
      .el-select {
        width: 100%;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.el-form /deep/ {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
